import { render, staticRenderFns } from "./WindowDescription.vue?vue&type=template&id=7664475c&scoped=true"
import script from "./WindowDescription.vue?vue&type=script&lang=ts"
export * from "./WindowDescription.vue?vue&type=script&lang=ts"
import style0 from "./WindowDescription.vue?vue&type=style&index=0&id=7664475c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7664475c",
  null
  
)

export default component.exports